import 'css-chunksrc/client/pages/projectPage/synthesisPage/monitoring/styles.scss';export default {
  "progressions": "_progressions_zmqwq_1",
  "milestones": "_milestones_zmqwq_10",
  "fallback": "_fallback_zmqwq_16"
};